<script>

export default {
  name: 'SiteHeader',
  template: '#site-header-template'
};

</script>
